import React from 'react';
import { MdOutlineShoppingCartCheckout, MdOutlineAddShoppingCart, MdOutlineShoppingBag } from 'react-icons/md';
import { useIntl } from 'react-intl';
import { useComposition, useFrami, useModal, useNavigation, useOrder, usePrice } from '../../context';
import {
    LOWDPI,
    MISSING_PHOTOS,
    PASSEPARTOUTMISMATCH,
    TEMPLATESELECT,
    VOUCHER_MISMATCH,
} from '../../data/constants';
import { CHECKOUT } from '../../providers/NavigationProvider';
import FramiButton from '../common/FramiButton';


const AddToCartButtonBase = ({ className, showPrice }) => {
    const {
        currentComp,
        missingImages,
        lowDPI,
        minVoucherAmount,
        passepartoutMismatch,
        voucherMismatch,
    } = useComposition();
    const { currentFrami } = useFrami();
    const { order, isReloading, addCompositionToCart, reloadOrder } = useOrder();
    const { openDrawer } = useNavigation();
    const { openModal } = useModal();
    const { formatPrice } = usePrice();
    const intl = useIntl();

    const isOrdered = order && order?.compositions?.some((c) => ((
        c.frami === currentComp?.frami && !currentComp?.is_voucher && c.is_sample === currentComp?.is_sample
    ) || c.id === currentComp?.id));
    const leftIcon = <MdOutlineShoppingBag />
    const actionButtonTitle = intl.formatMessage(
        { id: isOrdered ? 'studio.button.action.open_basket' : 'studio.button.action.basket' },
    );
    const actionButtonCy = isOrdered ? 'open-basket' : 'add-to-basket';

    const disabled = currentComp?.price?.rounded?.total === 0 ||
        // isReloading ||
        missingImages ||
        (currentComp?.is_voucher && ((currentComp?.voucher_amount < minVoucherAmount) || voucherMismatch));

    const handleClick = async () => {
        if (missingImages) {
            openModal('basket', { step: MISSING_PHOTOS });
        } else if (currentComp?.is_voucher && ((currentComp?.voucher_amount < minVoucherAmount) || voucherMismatch)) {
            openModal('basket', { step: VOUCHER_MISMATCH });
        } else if (lowDPI && !currentFrami.suppress_dpi_warning && !currentComp.is_voucher) {
            openModal('basket', { step: LOWDPI });
        } else if (Object.values(passepartoutMismatch).some((v) => v === true)) {
            openModal('basket', { step: PASSEPARTOUTMISMATCH });
        } else if (order && order.compositions.find((c) => c.id === currentComp.id)) {
            openDrawer(CHECKOUT);
            await reloadOrder();
        } else {
            if (currentComp.is_voucher || currentComp.baseline_data) {
                openDrawer(CHECKOUT);
                await addCompositionToCart(currentComp);
            } else {
                openModal('basket', { step: TEMPLATESELECT });
            }
        }
    }

    return (
        <FramiButton
            style={{ width: '100%' }}
            className={`${className} ${disabled ? 'disabled' : ''}`}
            dataPh={'floating bottom add to cart'}
            leftIcon={leftIcon}
            variant={disabled ? "disabled" : "primary"}
            // disabled={disabled}
            // loading={isReloading}
            title={showPrice ? (!isNaN(currentComp?.price?.rounded.discounted) && formatPrice(currentComp?.price?.rounded.discounted)) : actionButtonTitle}
            dataCy={actionButtonCy}
            onClick={handleClick}
        />
    );
};

export default AddToCartButtonBase;
